module.exports = require("react-collapse");


/*****************
 ** WEBPACK FOOTER
 ** external "react-collapse"
 ** module id = 66
 ** module chunks = 0
 **/